import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DECORATOR__ui_without_component } from '../../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD_SD__conditioning_masked } from '../../guidance/FIELD_SD__conditioning_masked';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

export class FIELD_SD__list_conditioning_masked extends FIELD__list_base_generic<FIELD_SD__conditioning_masked> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_SD__LIST_CONDITIONING_MASKED;

  /*
   * STATIC METHODS
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.CONDITIONING_SD_MASKED;
  }

  protected override _create_item_internal__default() {
    return new FIELD_SD__conditioning_masked();
  }

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }
}
